import React, { FC, useEffect, useState } from 'react'
import { StyleSheet, View } from 'react-native'
import { AppText } from '@views/components'
import { Slider } from '@rneui/base'

interface ISliderProps {
  onChange: any
  onBlur: any
  value: any
  isDisabled?: boolean
}

export const RNSlider: FC<ISliderProps> = ({ value, onChange, isDisabled }) => {
  const [sliderValuePosition, setSliderValuePosition] = useState<number>(2)

  useEffect(() => {
    if (value) {
      setSliderValuePosition(7 * (value - 1))
    }
  }, [value])

  return (
    <View>
      <Slider
        step={1}
        disabled={isDisabled}
        minimumTrackTintColor={'#3b2df5'}
        maximumTrackTintColor={'#f6f6f8'}
        minimumValue={1}
        maximumValue={12}
        thumbStyle={styles.thumbStyle}
        value={value || 1}
        onValueChange={(OnChangeSliderValue) => {
          onChange(OnChangeSliderValue)
          return
        }}
        style={styles.slider}
        thumbTintColor={'#1fa0f0'}
        allowTouchTrack={true}
      />
      <View style={styles.sliderOptionsContainer}>
        <AppText>1</AppText>
        <AppText>6</AppText>
        <AppText>12</AppText>
      </View>
      <View style={styles.sliderValueContainer}>
        <View
          style={{
            position: 'absolute',
            left: `${sliderValuePosition}%`,
            top: -30,
            shadowColor: '#000',
            shadowOffset: {
              width: 0,
              height: 4,
            },
            shadowOpacity: 0.3,
            shadowRadius: 4.65,
            elevation: 8,
            borderRadius: 10,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderColor: 'transparent',
            borderWidth: 5,
            backgroundColor: '#fff',
          }}>
          <AppText style={styles.textValue}>
            {value || 1} {value > 1 ? 'months' : 'month'}
          </AppText>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  sliderOptionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#fff',
    justifyContent: 'space-between',
  },
  textValue: {
    margin: 6,
  },
  sliderValueContainer: {
    display: 'flex',
    width: '100%',
  },
  slider: {
    width: '100%',
    opacity: 10,
    height: 50,
  },
  thumbStyle: {
    width: 24,
    height: 24,
  },
})
